import React from 'react';
import { PropTypes } from 'prop-types';
export default function Overlay(props) {
  if (!props.open) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "overlay",
    onClick: props.onClick
  }) // cursor-default
  ;
}
Overlay.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
//# sourceMappingURL=Overlay.js.map